import styled from 'styled-components';

export const SameRowWithTooltip = styled.div`
  display: flex;
  align-items: center;
  margin-right: -12px;
  justify-content: space-between;
`;

export const SameRowNoTooltip = styled.div`
  margin-right: 34px;
`;

export const RadioTooltipContainer = styled.div`
  position: relative;
  bottom: 12px;
`;

export const LabelTooltip = styled.h4`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px;
`;
